export default [
  {
    path: '/v3/restrict-access',
    name: 'restrict-access',
    component: () => import('@/modules/erros/views/pages/RestrictAccess.vue'),
    meta: {
      title: 'Área restrita',
    },
  },
  {
    path: '/v3/survey-not-found',
    name: 'survey-not-found',
    component: () => import('@/modules/erros/views/pages/SurveyNotFound.vue'),
    meta: {
      title: 'Pesquisa não encontrada',
    },
  },
]
